import { createSelector } from 'reselect';

export const selectFocus = createSelector(
  ({ focusManager }) => focusManager,
  ({ focus }) => focus,
);
export const selectIsDocumentFocused = createSelector(
  ({ focusManager }) => focusManager,
  ({ isDocumentFocused }) => isDocumentFocused,
);
